import {
  Box, Container, Typography, Card, CardContent,
  Button, Grid, Chip,
  Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'

const plans = [
  {
    tier: 'FREE FOREVER',
    name: 'Starter',
    price: '₹0',
    period: '/month',
    desc: 'Try JyotishAI and see if the stars align for you',
    featured: false,
    features: [
      'Basic daily horoscope',
      '3 Pandit AI questions per day',
      'Basic Kundali summary',
      '1 compatibility check',
    ],
  },
  {
    tier: 'MOST POPULAR',
    name: 'Pro',
    price: '₹299',
    period: '/month',
    desc: 'Full astrology guidance for every area of your life',
    featured: true,
    badge: 'Most popular',
    features: [
      'Full Kundali report + PDF download',
      'Unlimited Pandit AI questions',
      'Monthly + yearly forecast',
      'Unlimited compatibility checks',
      'Detailed remedies + gemstone guide',
      'Daily WhatsApp horoscope',
    ],
  },
  {
    tier: 'ONE TIME',
    name: 'Single reading',
    price: '₹99',
    period: '/reading',
    desc: 'One complete reading — no subscription needed',
    featured: false,
    features: [
      'Full Kundali reading',
      '10 questions to Pandit AI',
      'Compatibility report',
      'Download PDF report',
      'Marriage timing prediction',
    ],
  },
]

const faqs = [
  {
    q: 'Is this a real astrologer?',
    a: 'No — Pandit Aryan is powered by AI. We are always transparent. Ancient Vedic principles + modern AI gives personalised guidance.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes — cancel with one click, no questions asked. Free plan stays active forever.',
  },
  {
    q: 'How accurate are the readings?',
    a: 'Trained on authentic Vedic astrology texts. Readings are for guidance — treat them as wisdom, not certainty.',
  },
  {
    q: 'What payment methods are accepted?',
    a: 'UPI, GPay, PhonePe, Paytm, all debit/credit cards, and net banking through Instamojo.',
  },
]

export default function Pricing() {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>

      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <AutoAwesomeIcon sx={{ fontSize: 36,
          color: '#8B7FFF', mb: 1, display: 'block', mx: 'auto' }} />
        <Typography variant="h4" fontWeight={500}
          sx={{ color: '#E8E6FF', mb: 1 }}>
          Simple, honest pricing
        </Typography>
        <Typography sx={{ color: '#8B85B8', fontSize: 14 }}>
          AI-powered Vedic astrology · Cancel anytime · Always transparent
        </Typography>
      </Box>

      <Grid container spacing={3} sx={{ mb: 5 }}>
        {plans.map(p => (
          <Grid item xs={12} sm={4} key={p.name}>
            <Card sx={{
              height: '100%', position: 'relative',
              border: p.featured
                ? '1.5px solid #534AB7 !important'
                : '1px solid #1E1A3A',
            }}>
              {p.badge && (
                <Chip label={p.badge} size="small"
                  sx={{
                    position: 'absolute', top: -12,
                    left: '50%', transform: 'translateX(-50%)',
                    fontSize: 10, height: 22,
                  }} />
              )}
              <CardContent sx={{ p: 3 }}>
                <Typography variant="caption"
                  sx={{ color: '#4A4575', letterSpacing: 1,
                    display: 'block', mb: 0.5 }}>
                  {p.tier}
                </Typography>
                <Typography fontWeight={500}
                  sx={{ color: '#E8E6FF', fontSize: 15, mb: 0.5 }}>
                  {p.name}
                </Typography>
                <Box sx={{ display: 'flex',
                  alignItems: 'baseline', gap: 0.5, mb: 1 }}>
                  <Typography variant="h4" fontWeight={600}
                    sx={{ color: '#8B7FFF' }}>
                    {p.price}
                  </Typography>
                  <Typography variant="body2"
                    sx={{ color: '#8B85B8' }}>
                    {p.period}
                  </Typography>
                </Box>
                <Typography variant="body2"
                  sx={{ color: '#8B85B8', mb: 2,
                    pb: 2, borderBottom: '1px solid #1E1A3A' }}>
                  {p.desc}
                </Typography>
                <Box sx={{ display: 'flex',
                  flexDirection: 'column', gap: 1.2, mb: 3 }}>
                  {p.features.map(f => (
                    <Box key={f} sx={{ display: 'flex',
                      alignItems: 'flex-start', gap: 1 }}>
                      <CheckIcon sx={{ fontSize: 15,
                        color: '#639922', mt: 0.2, flexShrink: 0 }} />
                      <Typography variant="body2"
                        sx={{ color: '#8B85B8', fontSize: 12 }}>
                        {f}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Button fullWidth
                  variant={p.featured ? 'contained' : 'outlined'}
                  sx={{
                    py: 1.2, borderRadius: 2,
                    ...(p.featured ? {} : {
                      borderColor: '#2A2550',
                      color: '#A89EFF',
                    }),
                  }}>
                  {p.name === 'Starter' ? 'Start free' :
                   p.name === 'Pro' ? 'Get Pro — ₹299/mo' :
                   'Buy one reading'}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h6" fontWeight={500}
        sx={{ color: '#E8E6FF', mb: 2 }}>
        Frequently asked questions
      </Typography>

      {faqs.map(f => (
        <Accordion key={f.q} sx={{ mb: 1 }}>
          <AccordionSummary expandIcon={
            <ExpandMoreIcon sx={{ color: '#8B85B8' }} />}>
            <Typography fontWeight={500}
              sx={{ color: '#E8E6FF', fontSize: 13 }}>
              {f.q}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2"
              sx={{ color: '#8B85B8', lineHeight: 1.7 }}>
              {f.a}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}

    </Container>
  )
}